import React, { useState, useRef, Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import Loader from './Loader';
import Timeline_item_event from './Timeline_item_event';
import ConfirmedIcon from '@material-ui/icons/Check'
import ErrorIcon from '@material-ui/icons/Close';
import PersonIcon from '@material-ui/icons/Person';
import MaybeIcon from '@material-ui/icons/HelpOutline';
import EventIcon from '@material-ui/icons/Event';
import axios from 'axios';

export default function TimelineEmailEvents(props) {
  const [meetingEvents, setMeetingEvents] = useState(undefined);
  let first_time=useRef(true);

  if(first_time.current==true && props.load==false){
    first_time.current=false;
    let all_events=[];
    for(let ct of props.timeline_item.contact_timeline_items){
      let name=(ct.contact==null)?null:ct.contact.first_name+' '+ct.contact.last_name;
      if(ct.contact.first_name==null && ct.contact.last_name==null){name=ct.contact.email;}
      if(ct.contact_meeting_responses!=undefined && ct.contact_meeting_responses[0]!=undefined && ct.contact_meeting_responses[0].organiser!=true){all_events.push({title:'Invited '+name, icon:<PersonIcon color='primary'/>, date_time:ct.connected_on});}
      let recent=null; for(let resp of ct.contact_meeting_responses){if(resp.response_status!='NO_RESPONSE' && resp.response_status!='ORGANISER'){recent=resp;}}
      if(recent!=null){all_events.push({title:(recent.response_status=='ACCEPTED')?name+' confirmed':(recent.response_status=='DECLINED')?name+' declined':(recent.response_status=='MAYBE')?name+' might join':undefined, icon:(recent.response_status=='ACCEPTED')?<ConfirmedIcon style={{color:'green'}}/>:(recent.response_status=='DECLINED')?<ErrorIcon style={{color:'red'}}/>:(recent.response_status=='MAYBE')?<MaybeIcon style={{color:'orange'}}/>:undefined, date_time:recent.date_time})}
    }
    if(props.timeline_item.timeline_item_contact_suggestions!=undefined){
      for(let ct of props.timeline_item.timeline_item_contact_suggestions){
        let name=ct.first_name+' '+ct.last_name;
        if(ct.first_name==null && ct.last_name==null){name=ct.email;}
        if(ct.contact_meeting_responses!=undefined && ct.contact_meeting_responses[0]!=undefined && ct.contact_meeting_responses[0].organiser!=true){all_events.push({title:'Invited '+name, icon:<PersonIcon color='primary'/>, date_time:ct.created_at});}
        let recent=null; for(let resp of ct.contact_meeting_responses){if(resp.response_status!='NO_RESPONSE' && resp.response_status!='ORGANISER'){recent=resp;}}
        if(recent!=null){all_events.push({title:(recent.response_status=='ACCEPTED')?name+' confirmed':(recent.response_status=='DECLINED')?name+' declined':(recent.response_status=='MAYBE')?name+' might join':undefined, icon:(recent.response_status=='ACCEPTED')?<ConfirmedIcon style={{color:'green'}}/>:(recent.response_status=='DECLINED')?<ErrorIcon style={{color:'red'}}/>:(recent.response_status=='MAYBE')?<MaybeIcon style={{color:'orange'}}/>:undefined, date_time:recent.date_time})}
    }}
    for(let ut of props.timeline_item.user_workspace_timeline_items){
        let uw=props.workspace.all_user_workspaces[ut.user_workspace_id];
        let name=(uw==null)?null:uw.first_name+' '+uw.last_name;
        if(uw!=null && uw.first_name==null && uw.last_name==null){name=uw.email;}
        if(ut.user_workspace_meeting_responses!=undefined && ut.user_workspace_meeting_responses[0]!=undefined && ut.user_workspace_meeting_responses[0].organiser!=true){all_events.push({title:'Invited '+name, icon:<PersonIcon color='primary'/>, date_time:ut.connected_on});}
        let recent=null; for(let resp of ut.user_workspace_meeting_responses){if(resp.response_status!='NO_RESPONSE' && resp.response_status!='ORGANISER'){recent=resp;}}
        if(recent!=null){all_events.push({title:(recent.response_status=='ACCEPTED')?name+' confirmed':(recent.response_status=='DECLINED')?name+' declined':(recent.response_status=='MAYBE')?name+' might join':undefined, icon:(recent.response_status=='ACCEPTED')?<ConfirmedIcon style={{color:'green'}}/>:(recent.response_status=='DECLINED')?<ErrorIcon style={{color:'red'}}/>:(recent.response_status=='MAYBE')?<MaybeIcon style={{color:'orange'}}/>:undefined, date_time:recent.date_time})}
    }
    all_events.push({title:'Meeting', icon:<EventIcon color='primary'/>, date_time:props.timeline_item.date_time});
    all_events.sort((a, b) => {
      const dateA = new Date(a.date_time);
      const dateB = new Date(b.date_time);
      return dateA - dateB;
    });
    setMeetingEvents(all_events);
  }


  return (
    <Fragment>
      {(props.load==true || meetingEvents === undefined)? (
        <div style={{ height: '100%', width: '100%' }}>
          <Loader loading embed />
        </div>
      ) : (
        <Fragment>
          {meetingEvents.map((ee, index) => (<Timeline_item_event index={index} date_time={ee.date_time} title={ee.title} icon={ee.icon} extra_content={ee.extra_content}/>))}
        </Fragment>
      )}
    </Fragment>
  );
}
